import React from 'react';
import { ExternalLink, ArrowRight } from 'lucide-react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import portfolioData from '../data/mock';

const Projects = () => {
  return (
    <section id="projects" className="py-24 bg-stone-900">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-stone-100 mb-6">
            Proyectos Destacados
          </h2>
          <p className="text-xl text-stone-400 max-w-3xl mx-auto">
            Casos de éxito que demuestran la aplicación práctica de tecnología avanzada 
            en sistemas agronómicos modernos
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {portfolioData.projects.map((project) => (
            <Card key={project.id} className="bg-stone-800/50 border-stone-700 overflow-hidden hover:bg-stone-800/70 transition-all duration-500 group">
              {/* Project Image */}
              <div className="relative aspect-[16/10] overflow-hidden">
                <img 
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-stone-900/80 to-transparent"></div>
              </div>

              {/* Project Content */}
              <div className="p-8">
                <div className="space-y-4">
                  <h3 className="text-2xl font-bold text-stone-100 leading-tight">
                    {project.title}
                  </h3>
                  <p className="text-stone-300 leading-relaxed">
                    {project.description}
                  </p>
                  
                  {/* Tags */}
                  <div className="flex flex-wrap gap-2">
                    {project.tags.map((tag, tagIndex) => (
                      <Badge 
                        key={tagIndex}
                        variant="outline" 
                        className="border-yellow-600/30 text-yellow-600 bg-yellow-600/10"
                      >
                        {tag}
                      </Badge>
                    ))}
                  </div>

                  {/* Project Link */}
                  <div className="pt-4">
                    <Button 
                      variant="ghost" 
                      className="text-yellow-600 hover:text-yellow-500 hover:bg-yellow-600/10 p-0 h-auto font-semibold group/btn"
                    >
                      Ver Detalles del Proyecto
                      <ArrowRight size={16} className="ml-2 group-hover/btn:translate-x-1 transition-transform" />
                    </Button>
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* Additional Projects CTA */}
        <div className="mt-16 text-center">
          <Card className="bg-olive-600 border-olive-500 p-12 max-w-4xl mx-auto">
            <h3 className="text-3xl font-bold text-white mb-4">
              ¿Interesado en Colaborar?
            </h3>
            <p className="text-stone-100 text-lg mb-8 leading-relaxed">
              Estos proyectos representan solo una muestra de mi experiencia en transformación agrícola. 
              Cada iniciativa combina innovación tecnológica con conocimiento práctico para entregar 
              resultados medibles y sostenibles.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                className="bg-white text-olive-600 hover:bg-stone-100 font-semibold px-8 py-3"
                onClick={() => {
                  const contactSection = document.querySelector('#contact');
                  if (contactSection) {
                    contactSection.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
              >
                Discutir Tu Proyecto
              </Button>
              <Button 
                variant="outline"
                className="border-white text-white hover:bg-white hover:text-olive-600 px-8 py-3"
              >
                <ExternalLink size={16} className="mr-2" />
                Ver Más Casos de Estudio
              </Button>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Projects;